"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectCurrencyProvider = exports.useProjectCurrency = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var useProjectCurrency = function () {
    var projectCurrency = (0, react_2.useContext)(ProjectCurrencyContext);
    if (!projectCurrency) {
        throw new Error("useProjectCurrency can only be called in the context of a ProjectCurrencyProvider");
    }
    return projectCurrency;
};
exports.useProjectCurrency = useProjectCurrency;
var ProjectCurrencyContext = (0, react_2.createContext)(null);
var ProjectCurrencyProvider = function (_a) {
    var children = _a.children, projectCurrency = _a.projectCurrency;
    return react_1.default.createElement(ProjectCurrencyContext.Provider, { value: projectCurrency }, children);
};
exports.ProjectCurrencyProvider = ProjectCurrencyProvider;
